<template>
  <div :class="{'title-wrapper': true, 'title-wrapper--reverse': reverse}">
    <component :is="headingType" :class="{'title':true, 'title--small': small}">
      {{ title }}
    </component>
    <span class="subtitle">
      {{ subtitle }}
    </span>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    headingType: {
      type: String,
      default: "h2",
    },
    small: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },

  },
};
</script>

<style scoped lang="scss">
/* Title */
@font-face {
  font-family: 'Quablo';
  src: url('../assets/fonts/Quablo-Medium.eot');
  src: url('../assets/fonts/Quablo-Medium.eot?#iefix') format('embedded-opentype'),
       url('../assets/fonts/Quablo-Medium.woff2') format('woff2'),
       url('../assets/fonts/Quablo-Medium.woff') format('woff'),
       url('../assets/fonts/Quablo-Medium.ttf') format('truetype');
  font-weight: 500;
  font-style: normal;
  font-display: swap; /* optional, improves performance */
}

.title-wrapper {
  display: flex;
  flex-direction: column;
  &--reverse {
    flex-direction: column-reverse;
  }
}

.title {
  font-family: "Quablo";
  text-transform: uppercase;
  line-height: 1.2;
  font-weight: 800;
  font-size: 5vw;
  font-size: clamp(2.125rem, 0.9489rem + 5.2273vw, 5rem);
  
  &--small {
    
    font-size: clamp(2.55rem, 1.9952rem + 2.4659vw, 3.9063rem);
  }
  
  &:is(h3){
    font-size: clamp(1.44rem, 1.2301rem + 0.933vw, 1.9531rem);
    text-transform: lowercase;
  }
}

.subtitle {
  font-size: clamp(2rem, 2vw, 2vw);
  font-family: "Quablo";
}

</style>
